export default {
  required: "Campo obrigatório",
  unique: "Campo deve ser único",
};
